<div class="card m-3">
  <div class="card-header d-flex justify-content-between align-items-baseline">
    <h3 class="card-title">
      Behörden - Liste
      <small *ngIf="loading">Lädt...</small>
    </h3>

    <span>
      <button (click)="setFilter($event)" class="btn btn-outline-secondary me-2"
        [title]="'Filter' + (showFilter ? ' ausblenden': ' einblenden')" type="button">
        <i class="fa fa-filter"></i> Filter {{ showFilter ? 'ausblenden' : 'einblenden' }}
      </button>
      <span>
        <a [routerLink]="['/behoerden/neu']" class="btn btn-success">
          <i class="fa fa-plus"></i> Neue Behörde anlegen
        </a>
      </span>
    </span>
  </div>

  <form (submit)="onFilter(false)" [formGroup]="form">
    <table class="table table-striped mb-0" *ngIf="entities.length > 0 || showFilter">
      <thead>
        <tr>
          <th>
            ID
          </th>
          <th>
            <a (click)="toggleSort('prefix')" [class]="'sort-' + getSortingDir('prefix')">Präfix</a>
          </th>
          <th>
            <a (click)="toggleSort('identifier')" [class]="'sort-' + getSortingDir('identifier')">Behördenkennung</a>
          </th>
          <th>
            <a (click)="toggleSort('active')" [class]="'sort-' + getSortingDir('active')">Aktiv</a>
          </th>
          <th>
            <a (click)="toggleSort('target')" [class]="'sort-' + getSortingDir('target')">Endpunkt</a>
          </th>
          <th class="right-align">Aktionen</th>
        </tr>
        <tr *ngIf="showFilter">
          <th class="search-column">
            <app-search-column elementType="number" placeholderValue="ID" formGroupNameValue="id" [data]="filter">
            </app-search-column>
          </th>
          <th class="search-column">
            <app-search-column placeholderValue="Behördenpräfix" formGroupNameValue="prefix" [data]="filter">
            </app-search-column>
          </th>
          <th class="search-column">
            <app-search-column placeholderValue="Behördenkennung" formGroupNameValue="identifier" [data]="filter">
            </app-search-column>
          </th>
          <th class="search-column">
            <app-search-column elementType="boolean" placeholderValue="Aktiv" formGroupNameValue="active"
              [data]="filter"></app-search-column>
          </th>
          <th class="search-column">
            <app-search-column placeholderValue="Endpunkt" formGroupNameValue="target.to"
              [data]="filter"></app-search-column>
          </th>
          <th class="search-column filter-buttons right-align">
            <button class="btn btn-outline-secondary btn-sm" type="submit" title="Filtern"><i
                class="fa fa-filter"></i></button>
            <button class="btn btn-outline-secondary btn-sm" (click)="onFilter(true)" type="button"
              title="Filter aufheben"><i class="fa fa-ban"></i></button>
            <app-base-list-info></app-base-list-info>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let authority of entities">
          <ng-container *ngIf="authority.defaultRoute">
            <td>
              {{ authority.id }}
            </td>
            <td>
              <a [routerLink]="['/behoerden', authority.id]">
                {{ authority.prefix }}
              </a>
            </td>
            <td>
              <a [routerLink]="['/behoerden', authority.id]">
                {{ authority.identifier }}
              </a>
            </td>
            <td>
              {{ authority.active ? 'Ja' : 'Nein'}}
            </td>
            <td>
              {{ authority.target.to }}
            </td>
            <td class="right-align">
              <a (click)="onDelete($event, authority)" href="#" class="btn btn-danger btn-sm" title="Löschen">
                <i class="fa fa-trash-o"></i>
              </a>
            </td>
          </ng-container>
        </tr>
        <tr *ngFor="let authority of entities">
          <ng-container *ngIf="!authority.defaultRoute">
            <td>
              {{ authority.id }}
            </td>
            <td>
              <a [routerLink]="['/behoerden', authority.id]">
                {{ authority.prefix }}
              </a>
            </td>
            <td>
              <a [routerLink]="['/behoerden', authority.id]">
                {{ authority.identifier }}
              </a>
            </td>
            <td>
              {{ authority.active ? 'Ja' : 'Nein'}}
            </td>
            <td>
              {{ authority.to }}
            </td>
            <td class="right-align">
              <a (click)="onDelete($event, authority)" href="#" class="btn btn-danger btn-sm" title="Löschen">
                <i class="fa fa-trash-o"></i>
              </a>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </form>

  <div class="card-body" *ngIf="!loading && entities.length === 0">
    <div class="alert alert-info">
      Es wurden keine Einträge gefunden.
    </div>
  </div>

  <div class="card-footer" *ngIf="entities.length > 0">
    <div class="d-flex flex-row justify-content-end">
      <p-paginator currentPageReportTemplate="Zeige Einträge {first} bis {last} von {totalRecords}."
        [showCurrentPageReport]="true" styleClass="pull-right" [rows]="size"
        [rowsPerPageOptions]="[10,20,50,100,200,{showAll:'Alle'}]" [totalRecords]="totalsize"
        (onPageChange)="handlePageChange($event)"></p-paginator>
    </div>
  </div>
</div>
